// extracted by mini-css-extract-plugin
export default {"PatientInfoPop":"DoctorInfoPop_PatientInfoPop__xoR1D","header":"DoctorInfoPop_header__Ug3VB"};